import { Card, Divider, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { GeneralTable } from 'src/components/general';
import { MEDIA_PLAYLIST_TABLE_HEAD } from 'src/constants/tableHeads';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import useTable from 'src/hooks/useTable';
import { useFetchMediaGroupList } from 'src/network/media-group';
import MediaPlaylistTableRow from './MediaPlaylistTableRow';
import MediaPlaylistTableToolbar from './MediaPlaylistTableToolbar';

// ----------------------------------------------------------------------

export default function MediaPlaylistTableModal({ selectContentHandler }) {
  const useTableOptions = useTable();
  const { page, onChangePage } = useTableOptions;

  const [mediaPlaylistFilters] = useLocalStorage('mediaPlaylistFilters');

  const [tableData, setTableData] = useState([]);

  const [filterItems, setFilterItems] = useState({
    ID: mediaPlaylistFilters?.ID || -1,
    Title: mediaPlaylistFilters?.Title || '',
    GroupID: mediaPlaylistFilters?.GroupID || -1,
  });

  const { isLoading, data } = useFetchMediaGroupList(filterItems, page);

  useEffect(() => {
    if (data) {
      const result = data?.data?.items || [];
      setTableData([...result]);
    }
  }, [data, page, filterItems]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card sx={{ p: 3, overflow: 'visible' }}>
          <MediaPlaylistTableToolbar setFilterItems={setFilterItems} onChangePage={onChangePage} />

          <Divider sx={{ my: 2 }} />

          <GeneralTable
            tableContainerSX={{
              position: 'relative',
            }}
            rowID="MediaGroupID"
            tableData={tableData}
            headLabel={MEDIA_PLAYLIST_TABLE_HEAD}
            CustomTableRow={MediaPlaylistTableRow}
            useTableOptions={useTableOptions}
            hasDeleteOption={false}
            selectContentHandler={selectContentHandler}
            isLoading={isLoading}
          />
        </Card>
      </Grid>
    </Grid>
  );
}
